import React from 'react';
import styled from 'styled-components/macro';
import {
  blogRoutes,
  galleriesRoutes,
  modelsAndArtistsRoutes,
  moviesRoutes,
  updatesRoutes,
  routes,
} from '../../utils/router';
import { InternalMenuLink } from './InternalMenuLink';
import { MenuNavAnchor } from './styles';
import { LiveGirlsMenu } from 'src/client/containers/HeaderBar/LiveGirls/LiveGirlsMenu';
import { SeoCategoriesMenu } from 'src/client/components/SeoCategoriesMenu/SeoCategoriesMenu';
import { JoinButtons } from './JoinButtons';
import { SearchButton } from './SearchButton';
import { ActivityButton } from './ActivityButton';
import { SettingsButton } from './SettingsButton';
import { UserMenuButton } from './UserMenuButton';
import { MenuItemSlot } from './MenuItemSlot';
import { HeaderMenuController } from './helpers/useHeaderBarController';

type Props = {
  controller: HeaderMenuController;
};

export const HeaderMenuItems = (props: Props) => {
  const { controller } = props;
  const {
    containerRef,
    discountJoinUrl,
    isAuthResolved,
    isVisible,
    isVisibilityResolved,
    mainHeaderRef,
    registerItem,
    searchBarOpen,
    searchToggleRef,
    toggleNotificationsPanel,
    toggleRecentsBox,
    toggleSearchBar,
  } = controller;
  const isMenuReady = isAuthResolved && isVisibilityResolved;

  return (
    <HeaderMenuItemsContainer ref={containerRef} $isMenuReady={isMenuReady}>
      <MenuItemSlot isVisible={isVisible} itemId="updates" registerItem={registerItem}>
        <InternalMenuLink url="/updates" path={updatesRoutes.map((route) => route.path)}>
          UPDATES
        </InternalMenuLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="films" registerItem={registerItem}>
        <InternalMenuLink url="/erotic-films" path={moviesRoutes.map((route) => route.path)}>
          FILMS
        </InternalMenuLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="photos" registerItem={registerItem}>
        <InternalMenuLink url="/galleries" path={galleriesRoutes.map((route) => route.path)}>
          PHOTOS
        </InternalMenuLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="models" registerItem={registerItem}>
        <InternalMenuLink url="/models" path={modelsAndArtistsRoutes.map((route) => route.path)}>
          MODELS
        </InternalMenuLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="discounts" registerItem={registerItem}>
        <DiscountLink href={discountJoinUrl}>DISCOUNTS</DiscountLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="partners" registerItem={registerItem}>
        <InternalMenuLink url="/trusted-partners" path={routes.trustedPartners}>
          PARTNERS
        </InternalMenuLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="liveGirls" registerItem={registerItem}>
        <LiveGirlsMenu shouldRender />
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="blog" registerItem={registerItem}>
        <InternalMenuLink url="/blog" path={blogRoutes.map((route) => route.path)}>
          BLOG
        </InternalMenuLink>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="categories" registerItem={registerItem}>
        <SeoCategoriesMenu />
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="join" registerItem={registerItem}>
        <JoinButtons />
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="login" registerItem={registerItem}>
        <MenuNavAnchor href={`/login?r=${location.pathname.replace(/^\//, '')}`}>Sign In</MenuNavAnchor>
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="search" registerItem={registerItem}>
        <SearchButton
          onToggleSearchBar={toggleSearchBar}
          searchBarOpen={searchBarOpen}
          searchToggleRef={searchToggleRef}
        />
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="activity" registerItem={registerItem}>
        <ActivityButton mainHeader={mainHeaderRef} />
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="settings" registerItem={registerItem}>
        <SettingsButton />
      </MenuItemSlot>

      <MenuItemSlot isVisible={isVisible} itemId="userMenu" registerItem={registerItem}>
        <UserMenuButton
          mainHeader={mainHeaderRef}
          toggleRecentsBox={toggleRecentsBox}
          closeNotificationPanel={toggleNotificationsPanel}
        />
      </MenuItemSlot>
    </HeaderMenuItemsContainer>
  );
};

const HeaderMenuItemsContainer = styled.div<{ $isMenuReady: boolean }>`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  height: var(--header-row-height);
  overflow: hidden;
  visibility: ${(props) => (props.$isMenuReady ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.$isMenuReady ? 'auto' : 'none')};
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  > * {
    flex: 0 0 auto;
    min-height: var(--header-row-height);
    display: inline-flex;
    align-items: center;
  }
`;

const DiscountLink = styled(MenuNavAnchor)`
  color: #78c274 !important;
  display: inline-flex;

  &:hover {
    color: #b9ffb5 !important;
  }
`;
